export const paymentsConstants = {
  SET_SCRIPTS_LOADED: 'payments/SET_SCRIPTS_LOADED',
  SET_BRAINTREE_INSTANCE: 'payments/SET_BRAINTREE_INSTANCE',
};
